/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 15:10:17
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-28 11:52:57
 */
import { Pagination, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../app/store";
import { OrganizationParams } from "../../services/organizationMessage";
import { OrganizationListColumn } from "./columns";
import { OrganizationDetailModal } from "./modal";
import styles from "./OrganizationMessage.module.css";
import {
  getOrganizationListAsync,
  selectOrganizationData,
} from "./OrganizationMessageSlice";
import { OrganizationMessageQuerys } from "./query";

export const OrganizationListMessage = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [id, setId] = useState("");

  const [queries, setQueries] = useState<OrganizationParams>({
    pn: 1,
    ps: 10,
  });

  const page = useSelector(selectOrganizationData);

  useEffect(() => {
    if (JSON.stringify(queries) !== "{}") {
      dispatch(getOrganizationListAsync(queries));
    }
  }, [dispatch, queries]);

  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          height: "120px",
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
        }}
      >
        <div
          style={{
            flex: "1",
            background: "#fff",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <h3 style={{ fontWeight: "bold" }}>查询条件</h3>
          <OrganizationMessageQuerys
            onValueChange={(v) => {
              setQueries({ ...v, pn: 1, ps: 10 });
            }}
          />
        </div>
      </div>
      <div
        style={{ height: "calc(100% - 130px)" }}
        className={styles.OrganizationStation}
      >
        <div
          style={{
            width: "100%",
            height: "calc(100% - 55px)",
            overflow: "auto",
          }}
        >
          <Table
            rowKey={(record) => record.orgId}
            className={styles.OrganizationTable}
            pagination={false}
            style={{ height: "100%" }}
            dataSource={page.records}
            columns={OrganizationListColumn((t, id) => {
              if (t === "look") {
                setId(id.toString());
              }
            }, page.size * (page.current - 1))}
            onRow={(r) => ({
              onDoubleClick: () => setId(r.orgId.toString()),
            })}
          ></Table>
          <Pagination
            total={page.total}
            current={page.current}
            pageSize={page.size}
            showSizeChanger
            showQuickJumper
            style={{
              position: "absolute",
              bottom: "40px",
              right: "40px",
            }}
            showTotal={(total) => `共 ${total} 条`}
            onChange={(current, size) => {
              setQueries({ ...queries, pn: current, ps: size });
            }}
          />
        </div>
        <OrganizationDetailModal
          id={id}
          visible={!!id}
          onCancel={() => {
            setId("");
          }}
          onOk={() => {
            setId("");
          }}
        />
      </div>
    </div>
  );
};
